var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0583 11.9165L17.725 16.0832C17.6 17.3582 17.5 18.3332 15.2417 18.3332H4.75833C2.5 18.3332 2.4 17.3582 2.275 16.0832L1.94167 11.9165C1.875 11.2248 2.09167 10.5832 2.48333 10.0915C2.49167 10.0832 2.49167 10.0832 2.5 10.0748C2.95833 9.5165 3.65 9.1665 4.425 9.1665H15.575C16.35 9.1665 17.0333 9.5165 17.4833 10.0582C17.4917 10.0665 17.5 10.0748 17.5 10.0832C17.9083 10.5748 18.1333 11.2165 18.0583 11.9165Z",
    stroke: "#8F8888",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91669 9.52523V5.23356C2.91669 2.40023 3.62502 1.69189 6.45835 1.69189H7.51669C8.57502 1.69189 8.81669 2.00856 9.21669 2.54189L10.275 3.95856C10.5417 4.30856 10.7 4.52523 11.4084 4.52523H13.5334C16.3667 4.52523 17.075 5.23356 17.075 8.06689V9.55856",
    stroke: "#8F8888",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85834 14.1665H12.1417",
    stroke: "#8F8888",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.c7d415d10e169a63ed2d48ae3a126f3a.svg";
export { ForwardRef as ReactComponent };